import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function A() {
    const { useLang } = useGlobal();
    const { t } = useLang('solar60w');
    return (
        <div className={`solar-60w-A ${css['solar-60w-A']}`}>
            <div className="img-box">
                <NextImage src={require('@publicLocal/solar-60w/pc/1.jpg')} alt={t('sec1_title')} aria-label={t('sec1_title')} />
            </div>
            <div className="text-box">
                <p className="title">{t('sec1_title')}</p>
                <p className="desc">{t('sec1_desc')}</p>
            </div>
        </div>
    );
}
